/**
 * Finds the `[MM:SS]` and `[H:MM:SS]` times in an answer, which the video panel turns into seek
 * buttons. Plain .ts so `node --test` can load it.
 */
const TIMESTAMP = /\[(?:(\d{1,2}):)?(\d{1,2}):(\d{2})\](?!\()/g;

export interface Timestamp {
	/** Offsets of the bracketed time in the text, `end` exclusive. */
	start: number;
	end: number;
	seconds: number;
}

export function findTimestamps(text: string): Timestamp[] {
	const found: Timestamp[] = [];
	for (const match of text.matchAll(TIMESTAMP)) {
		const [hours, minutes, secs] = [Number(match[1] ?? 0), Number(match[2]), Number(match[3])];
		if (minutes > 59 || secs > 59) continue;
		found.push({ start: match.index, end: match.index + match[0].length, seconds: hours * 3600 + minutes * 60 + secs });
	}
	return found;
}
